export default {"src":"/_next/static/media/equa.cb5a6893.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};